module.exports = __webpack_public_path__ + "media/images/lb/620-350914927607203c08707a42c02d715e.svg";